import { IHtmlHighlight, PopoverConfiguration } from "../../../typings/annotate/annotation";
import useCommentContext from "../hooks/comment-context";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useRef, useState } from "react";
import { ChatBubbleLeftIcon } from "@heroicons/react/24/solid";
import { classNames } from "~/utils";

interface HighlightWrapperProps {
  highlight: IHtmlHighlight;
  popoverConfiguration: PopoverConfiguration;
  dataOffset: number;
  dataIndex: number;
  trackMetric: (name: string, options?: { [key: string]: any }) => void;
  articleID: string;
}
/* eslint-disable lingui/no-unlocalized-strings -- tailwind class names */
const markerToColorClass = {
  marker0: "bg-note hover:bg-note-hover dark:bg-note/40 dark:hover:bg-note-hover/60",
  marker1:
    "bg-comment hover:bg-comment-hover border-dashed border-b border-comment-foreground dark:bg-comment/50 dark:hover:bg-comment-hover/50",
  marker2:
    "bg-ai hover:bg-ai-hover border-dashed border-b border-ai-foreground dark:bg-ai/50 dark:hover:bg-ai-hover/50",
  default: "bg-note hover:bg-note-hover dark:bg-note/40 dark:hover:bg-note-hover/60",
} as { [key: string]: string };
/* eslint-enable lingui/no-unlocalized-strings */
export default function HighlightWrapper(props: React.PropsWithChildren<HighlightWrapperProps>) {
  const ref = useRef<HTMLSpanElement>(null);
  const commentContext = useCommentContext();

  return (
    <span
      ref={ref}
      className={classNames(
        markerToColorClass[props.highlight.model] ?? markerToColorClass.default,
        " cursor-pointer thread_" + props.highlight.id,
      )}
      data-offset={props.dataOffset}
      onClick={() => {
        commentContext.selectThread(props.highlight.id as string);
      }}
      onTouchStart={(e) => {
        e.stopPropagation();
        commentContext.selectThread(props.highlight.id as string);
      }}
      id={props.highlight.id}
    >
      {(!!props.highlight?.comments?.length || !!props.highlight.privateNote) &&
        props.dataIndex === (props.highlight.startParentID || 0) && (
          <span
            className={
              "inline-flex flex-col xl:flex-row items-start absolute w-7 items-center -right-[40px] xl:w-14  xl:-right-[64px] space-y-1 xl:space-y-0 xl:space-x-1 xl:justify-center xl:items-center"
            }
          >
            {!!props.highlight.privateNote && (
              <span
                className="h-6 w-6 bg-note-hover hover:bg-note-hover rounded-xs"
                onClick={() => commentContext.showNotes(props.highlight)}
              ></span>
            )}
            {!!props.highlight?.comments?.length && (
              <span className="h-8 w-8 relative" onClick={() => commentContext.showComments(props.highlight)}>
                <ChatBubbleLeftIcon
                  className={classNames(
                    "h-8 w-8",
                    props.highlight.model === "marker2"
                      ? "text-ai hover:text-ai-hover"
                      : "text-comment hover:text-comment-hover",
                  )}
                />
                <span
                  className={"absolute top-0 left-0 h-8 w-8 justify-center pt-1 flex text-sm text-comment-foreground"}
                >
                  {props.highlight.comments.length}
                </span>
              </span>
            )}
          </span>
        )}
      {props.children}
    </span>
  );
}
